import * as z from "zod";
import { null as zNull } from "zod";

/** The carrier's own account number (masked) per merchant carrier account, keyed by carrierAccountId. */
export const getCarrierAccountNumbers = {
  name: "getCarrierAccountNumbers" as const,
  input: zNull(),
  output: z.object({
    accountNumbers: z.array(
      z.object({
        carrierAccountId: z.string(),
        maskedAccountNumber: z.string(),
      }),
    ),
  }),
};
